<template>
	<div class="container" v-loading.fullscreen.lock="fullscreenLoading">
		<Header ref="headerRef" @custom-event="getToken"></Header>
		<div class="page_content">
			
			<!--添加客人-开始-->
			<el-dialog
			  title="添加客人"
			  :visible.sync="guestDialog"
			  :destroy-on-close="true"
			  width="500px">
			  <div class="add_guest_box">
			  	<div class="item">
					<span>姓名：</span>
					<input type="text" ref="guest_name" v-model="guest_name" class="inpt" maxlength="50" style="width: 300px;" placeholder="請輸入" />
				</div>
				<div class="item">
					<span>年齡：</span>
					<el-input-number v-model="guest_age" :min="minAge" :max="maxAge"></el-input-number>
				</div>
				<div class="item">
					<span>性別：</span>
					<el-radio v-model="guest_sex" label="男">男</el-radio>
					<el-radio v-model="guest_sex" label="女">女</el-radio>
				</div>
				<div class="btns">
					<el-button @click="guestDialog = false" style="width: 30%;">取 消</el-button>
					<el-button type="primary" @click="pushGuest()" style="width: 30%;">確 定</el-button>
				</div>
			  </div>
			</el-dialog>
			<!--添加客人-结束-->
			
			<!--面包屑与公共提醒-开始-->
			<div class="ext_head">
				<div class="bread_crumb">
					<a href="/tw/">首頁</a><span class="space">/</span><a href="/tw/ticket">景點門票</a><span class="space">/</span>自助下單
				</div>
			</div>
			<!--面包屑与公共提醒-结束-->
			
			<!--页面内容-开始-->
			<div class="booking_box">
				
				<!--左侧-开始-->
				<div class="bbox_left">
					<h1>自助下單</h1>
					<!--景点-开始-->
					<div class="bk_item">
						<div class="project_title">景點名稱</div>
						<div class="project_right_box">
							<div class="hotel_plan_box">
								<h3>{{ticketDetail.Title}}</h3>
							</div>
						</div>
					</div>
					<!--景点-结束-->
					<!--日期-开始-->
					<div class="bk_item">
						<div class="project_title">預訂日期</div>
						<div class="project_right_box">
							<div class="arrival_date_box">
								<el-date-picker
								v-model="bookingDay" 
								type="date" 
								:clearable=false
								:editable=false
								prefix-icon="none" 
								placeholder="選擇日期"
								:picker-options="pickerOptions"
								@change="changeDate"
								>
								</el-date-picker>
							</div>
						</div>
					</div>
					<!--日期-结束-->
					<!--客人信息-开始-->
					<div class="bk_item">
						<div class="project_title">客人資訊</div>
						<div class="project_right_box">
							<div class="guest_ctrl">
								<span @click="guestDialogHandle()">添加客人</span>
							</div>
							<div class="nothing" v-if="guestList.length==0">您還未添加任何客人哦！</div>
							<div class="guest_items"v-if="guestList.length>0">
								<div class="item" v-for="(item, index) in guestList" :key="index">
									<div class="remove" @click="removeGuest(index)" title="移除"></div>
									<div class="guest"><b>{{item.GuestName}}</b>，{{item.Sex}}，{{item.Age}}歲</div>
									<div class="price">{{item.PriceTitle}}：${{item.Price}}</div>
								</div>
							</div>
						</div>
					</div>
					<!--客人信息-结束-->
					<!--备注-开始-->
					<div class="bk_item">
						<div class="project_title">備註信息</div>
						<div class="project_right_box">
							<div class="remark_box">
								<div class="remark_input">
									<el-input type="textarea" 
									:rows="5" 
									placeholder="如需幫助請在此輸入您的需求!" 
									maxlength="200" 
									show-word-limit
									v-model="remark">
									</el-input>
								</div>
								<!-- <div class="friendly_tips">如因您提供的航班讯息出错，本公司不承担因此引起的责任。</div> -->
							</div>
						</div>
					</div>
					<!--备注-结束-->
					<!--联系人信息-开始-->
					<div class="bk_item">
						<div class="project_title">聯絡人信息</div>
						<div class="project_right_box">
							<div class="contact_box">
								<div class="item_box">
									<div class="l_title">姓名</div>
									<input type="text" ref="linkman" v-model="linkman" maxlength="50" class="r_input" placeholder="請輸入姓名（必填）" />
								</div>
								<div class="item_box">
									<div class="l_title">手機</div>
									<input type="text" ref="mobile" v-model="mobile" maxlength="20" class="r_input" placeholder="請輸入手機號碼（必填）" />
								</div>
								<div class="item_box">
									<div class="l_title">電子郵箱</div>
									<input type="text" ref="email" v-model="email" maxlength="50" class="r_input" placeholder="請輸入您的電子郵箱（必填）" />
								</div>
							</div>
						</div>
					</div>
					<!--联系人信息-结束-->
				</div>
				<!--左侧-结束-->

				<!--右侧-开始-->
				<div class="bbox_right">
					<div class="price_box">
						<div class="price">${{payablePrice}}</div>
						<div class="ext_price">含州稅 ${{taxRatePrice}}</div>
						<!-- <div class="friendly_tips">17岁(含)以下儿童免收占床费</div> -->
					</div>
					<div class="submit_btn">
						<el-button type="primary" round :loading="btnLoading" @click="submitBooking()">{{btnTxt}}</el-button>
					</div>
				</div>
				<!--右侧-结束-->
			</div>
			<!--页面内容-结束-->
		</div>
		<Footer></Footer>
	</div>
</template>


<script>
	import moment from 'moment'
	import {
		getTicketDetail,
		checkToken,
		getTicketPrice,
		submitTicketBooking,
	} from '@/api/index.js'
	import {
		mixin
	} from '@/utils/mixin.js'
	import Header from '@/components/tw_header.vue'
	import Footer from '@/components/tw_footer.vue'
	export default {
		name: 'TW_TicketBooking',
		mixins: [mixin],
		components: {
			Header,
			Footer,
		},
		data() {
			return {
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() < Date.now()+1 * 24 * 60 * 60 * 1000
					},
				},
				bookingDay: Date.now()+2 * 24 * 60 * 60 * 1000,
				total: 0,			//金额（不含税）
				taxRatePrice: 0,	//州税
				taxRate: 0.047,		//税率
				payablePrice: 0,	//应付金额
				
				Id: '', //景点门票Id
				fullscreenLoading: true, //loading状态
				language: 'tw', //语言版本
				terminal: 'pc', //终端，pc
				loginStatus: false,	//登录态
				token: null, //token
				
				ticketDetail: [], //详情
				priceList: [],	//价格列表
				guestList: [],	//客人列表
				guestDialog: false,	//添加客人弹窗状态
				guest_name: '',
				guest_age: 18,
				guest_sex: '男',
				minAge: 1,	//最小支持年龄
				maxAge: 100,	//最大支持年龄
				
				linkman: '',	//联系人姓名
				mobile: '',		//联系人手机
				email: '',		//联系人邮箱
				remark:'',	//备注
				
				btnLoading: false,
				btnTxt: '提交訂單',
			}
		},		
		created() {
			// 模拟获取url参数
			if (this.$route.query.Id != undefined && this.$route.query.Id !='') {
				this.Id = this.$route.query.Id
			}
			else{
				this.$message.error('Id不能為空');
			}
			
			// 验证BookingDate
			if(this.$route.query.BookingDate !=undefined && this.$route.query.BookingDate !='')
			{
				if(!isNaN(new Date(this.$route.query.BookingDate).getTime()))
				{
					this.bookingDay = new Date(this.$route.query.BookingDate+'T00:00:00').getTime()
				}
			}
		},
		
		methods: {
			//接收组件回传Token
			getToken(token)
			{
				this.token = token
				if(this.token !=null && this.token !='')
				{
					this.loginStatus = true
				}
				// 获取详情
				this.getData()
			},
			//获取数据
			async getData() {
				const { data: res } = await getTicketDetail(this.language, this.terminal, this.Id, this.token)
				if (res.errcode === 0) {
					this.ticketDetail = res.data					
					this.getPriceList()
					
				} else {
					this.$message.error(res.errmsg);
				}
			},
			//选定日期
			async changeDate()
			{
				this.getPriceList()
			},
			// 获取价格表
			async getPriceList()
			{
				this.fullscreenLoading = true
				const { data: res } = await getTicketPrice(this.language, this.Id, this.formattedDate(this.bookingDay), 0)
				this.fullscreenLoading = false
				if (res.errcode === 0) {
					if(res.data.ValidDateList.length>0)
					{
						this.priceList = res.data.ValidDateList[0].PriceList
						
						//取最小年龄
						let min = 1000
						this.priceList.forEach((item, index) => {
							if(item.Min < min) {
								min = item.Min
							}
							
							this.guestList.forEach((x, y) => {
								if(x.Age >= item.Min && x.Age <= item.Max)
								{
									x.PriceTitle = item.Title
									x.Price = parseFloat(item.DiscountPrice).toFixed(2)
								}
							})
						})
						this.minAge = min
						if(this.minAge == 0) this.minAge = 1
					}
					//计算金额
					this.calculatePrice()
				} else {
					this.$message.error(res.errmsg);
				}
			},
			//计算金额
			calculatePrice()
			{
				this.total = 0
				this.payablePrice = 0
				this.taxRatePrice = 0
				
				this.guestList.forEach((item, index) => {
					this.total += parseFloat(item.Price)
				})
				
				this.taxRatePrice = parseFloat(parseFloat(this.total) * parseFloat(this.taxRate)).toFixed(2)
				this.payablePrice = parseFloat(parseFloat(this.total) + parseFloat(this.taxRatePrice)).toFixed(2)
				this.total = parseFloat(this.total).toFixed(2)
			},
			// 添加客人
			guestDialogHandle()
			{
				this.guest_name = ''
				this.guest_age = 18
				this.guest_sex = '男'
				this.guestDialog = true
			},
			// 保存客人
			pushGuest()
			{
				if(this.guest_name == '')
				{
					this.$message.error('請輸入客人姓名')
					this.$refs.guest_name.focus()
					return
				}				
				this.guestDialog = false
				
				//根据年龄获取价格和标题
				let title = ''
				let price = 0
				this.priceList.forEach((item, index) => {
					if(this.guest_age >= item.Min && this.guest_age <= item.Max)
					{
						title = item.Title
						price = parseFloat(item.DiscountPrice).toFixed(2)
					}
				})
				
				let guest = {
					GuestName: this.guest_name,
					Age: this.guest_age,
					Sex: this.guest_sex,
					PriceTitle: title,
					Price: price
				}
				this.guestList.push(guest)
				
				//计算金额
				this.calculatePrice()
			},
			// 移除客人
			removeGuest(i)
			{
				this.guestList.splice(i, 1)
				
				//计算金额
				this.calculatePrice()
			},
			// 提交表单
			async submitBooking()
			{
				if(!this.loginStatus)
				{
					//调用头部组件中的登录方法
					this.$refs.headerRef.showHandleBox('login')
				}
				else
				{
					if(this.btnLoading)
					{
						return
					}
					
					if(this.guestList.length == 0)
					{
						this.$message.error('對不起，您還未添加任何客人。')
						return
					}
					if(this.payablePrice == 0)
					{
						this.$message.error('訂單金額錯誤。')
						return
					}
					
					if(this.linkman == '')
					{
						this.$message.error('請輸入聯絡人姓名。')
						this.$refs.linkman.focus()
						return
					}
					if(this.mobile == '')
					{
						this.$message.error('請輸入聯絡人手機號碼。')
						this.$refs.mobile.focus()
						return
					}
					if(this.email == '')
					{
						this.$message.error('請輸入聯絡人電子郵箱。')
						this.$refs.email.focus()
						return
					}
					const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
					if (!emailPattern.test(this.email)) {
						this.$message.error('聯絡人電子郵箱格式錯誤。')
						this.$refs.email.focus()
						return
					}
					
					this.btnLoading = true
					this.btnTxt = "提交中，請稍候..."
					this.fullscreenLoading = true
					
					//组装请求数据
					let params={
						TicketId: this.Id,
						Token: this.token,
						Terminal: this.terminal,
						Language: this.language,
						BookingDate: moment(this.bookingDay).format('YYYY-MM-DD'),
						LinkMan: this.linkman,
						Mobile: this.mobile,
						Email: this.email,
						Remark: this.remark,
						TotalPrice: this.total,
						TaxRatePrice: this.taxRatePrice,
						PayablePrice: this.payablePrice,
						PersonAmount: this.guestList.length,
						Guests: this.guestList,
					}					
					
					const { data: res } = await submitTicketBooking(params)
					if (res.errcode === 0) {
						this.$router.push({
							path: '/tw/user/booking_success?OrderNo='+res.data.OrderNo
						})
					} else {
						this.btnLoading = false
						this.btnTxt = "提交訂單"
						this.fullscreenLoading = false
						this.$message.error(res.errmsg);
					}
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.container {
		width: 100%;
		box-sizing: border-box;
		
		/*添加客人*/
		.add_guest_box {
			
			.item {
				margin: 20px 0;
				
				span {
					color: #111;
					display: inline-block;
					margin-right: 6px;
				}
				
				.inpt {
					height: 42px;
					line-height: 42px;
					font-size: 15px;
					box-sizing: border-box;
					padding: 0 6px;
					border: #999 solid 1px;
					color: #111;
					outline: 0;
				}
				::placeholder {
					color: #bbb;
				}
			}
			.btns {
				text-align: right;
			}
		}

	}
	
	
	.el-select {
		width: 100%;
	}
	
	.el-button {
		width: 100%;
		font-family: "PingFang SC", sans-serif, Helvetica, Arial;
		font-size: 15px;
		font-weight: 400;
		height: 42px;
		border-radius: 21px;
		-webkit-transition: all .3s ease;
	}
	.el-button--default {
		border: #666 solid 1px;
		color: #666;
		margin-left: 20px;
	}
	.el-button--default:hover {
		border: #3D7856 solid 1px;
		color: #3D7856;
	}
	.el-button.is-plain:focus  {
		border: #3D7856 solid 1px;
		color: #3D7856;
	}
	
	.el-button--primary {
		border: 0;
	}		
	.el-button--primary:focus {
		background-color: #3D7856;
	}
	.el-button--primary:hover {
		background-color: #000;
	}
</style>